import { connect } from 'react-redux'

import WorkSummaryWorkOrderCard from '../../components/work-summaries/work-summary-work-order-card'

function mapStateToProps (state, ownProps) {
  const workSummary = state.workSummaries[ownProps.workSummaryId]
  const summarizable = state[workSummary.summary.schema][workSummary.summary.id]

  return {
    workSummary,
    summarizable,
    pathname: ownProps.pathname || 'summaries'
  }
}

export default connect(mapStateToProps)(WorkSummaryWorkOrderCard)



// WEBPACK FOOTER //
// ./src/containers/work-summaries/work-summary-card-container.js